/** Two-decimal rounding for monetary amounts (minor units). */
export function roundMoney(v: number): number {
  return Math.round((Number(v) || 0) * 100) / 100
}
